import { portfolioItems } from '../data/works'

export default function Works() {
  return (
    <div className="mil-content">

            <div className="mil-scroll-wrapper transition-fade" id="swupMain">
                <div className="mil-container-fw">

                    <section className="mil-banner-sm mil-center">
                        <div className="mil-banner-top mil-up"></div>
                        <div className="mil-banner-title">
                            <h1 className="mil-h1-md mil-up mil-mb-60">Transforming Ideas<br />into Digital Products</h1>
                            <ul className="mil-breadcrumbs mil-up">
                                <li><a href="home-1.html">Homepage</a></li>
                                <li><a href="portfolio-1.html">Showcases</a></li>
                            </ul>
                        </div>
                    </section>

                    <section>
                        <div className="row align-items-center justify-content-between">

                            {portfolioItems.map((item) => (
                                <div className="col-lg-6" key={item.id}>
                                    <a href={item.link} className="mil-portfolio-item mil-mb-60" target="_blank">
                                        <div className="mil-cover-frame mil-up">
                                            <img src={item.image} alt={item.title} />
                                            </div>
                                            <div className="mil-description mil-up">
                                            <div>
                                                <p className="mil-upper mil-mb-5">{item.category}</p>
                                                <h3>{item.title}</h3>
                                            </div>
                                            <div className="mil-link mil-icon-link">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-right">
                                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                                    <polyline points="12 5 19 12 12 19"></polyline>
                                                </svg>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}

                            {/* <div className="col-lg-12">

                                <div className="mil-pagination mil-up">
                                    <div className="mil-divider"></div>
                                    <div className="mil-pagination-buttons">
                                        <a href="portfolio-1.html" className="mil-pagination-btn mil-active">1</a>
                                        <a href="portfolio-1.html" className="mil-pagination-btn">2</a>
                                        <a href="portfolio-1.html" className="mil-pagination-btn">3</a>
                                        <a href="portfolio-1.html" className="mil-pagination-btn">4</a>
                                    </div>
                                </div>

                            </div> */}
                        </div>
                    </section>

                    <section id="about" className="mil-p-90-90">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="mil-center">
                                    <h1 className="mil-h1-sm mil-up mil-mb-60">Ready to bring your ideas to life? I'm here to help</h1>
                                    <div className="mil-up">
                                        <a href="contact.html" className="mil-btn mil-sm-btn">Contact me</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <footer className="mil-fw">
                        <p className="mil-light-soft">© 2023. Courtney. All rights reserved.</p>
                        <p className="mil-light-soft">Author: &nbsp;<a href="https://themeforest.net/user/millerdigitaldesign/portfolio" target="_blank">Nazar Miller</a></p>
                    </footer>
                </div>

            </div>

            <div className="mil-right-banner" id="scene" style={{"display": "none"}}>
                <div className="mil-progress-track">
                    <div className="mil-progress"></div>
                </div>
                <div className="mil-banner-wrapper" data-depth="1">
                    <div id="swupBg" className="mil-banner-frame"></div>
                </div>
                <div className="mil-banner-wrapper" data-depth="0.2">
                    <div id="swupPerson" className="mil-banner-frame"></div>
                </div>
                <div className="mil-flying-skills" data-depth="0.1">
                    <div id="swupSkills" className="mil-skills-frame">
                        <div className="mil-item" style={{"top": "30%", "left": "10%"}}>
                            <img src="img/logos/1.jpg" alt="logo" />
                        </div>
                        <div className="mil-item" style={{"bottom": "15%", "left": "20%"}}>
                            <img src="img/logos/2.jpg" alt="logo" />
                        </div>
                        <div className="mil-item" style={{"bottom": "45%", "right": "15%"}}>
                            <img src="img/logos/3.jpg" alt="logo" />
                        </div>
                        <div className="mil-el mil-addition-el-1">+</div>
                        <div className="mil-el mil-addition-el-2">+</div>
                        <div className="mil-el mil-addition-el-3"></div>
                        <div className="mil-el mil-addition-el-4"></div>
                    </div>
                </div>
            </div>

        </div>
  )
}
